import { createStyles, MantineTheme } from '@mantine/core';

export const useStyles = createStyles((theme: MantineTheme) => ({
    buttonStack: { color: theme.colors.gray[9], paddingLeft: '5px', paddingRight: '5px' },
    userStack: { color: theme.colors.gray[9] },
    button: { display: 'flex', justifyContent: 'flex-start', fontWeight: 'normal' }
}));
